"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWrenchFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.82 10.43l-.4-1.78-4.79 4.79c-.57.56-.75.56-1 .56a3.83 3.83 0 01-2.18-1.36 3.83 3.83 0 01-1.3-2.23c0-.27 0-.47.58-1l4.76-4.75-1.73-.42A6.94 6.94 0 0020.11 4a7.84 7.84 0 00-5.65 2.27l-.06.07c-3.1 3.08-2.77 6-1.83 8.05l-8.45 8.4a3.63 3.63 0 000 5.09A3.54 3.54 0 006.56 29a3.56 3.56 0 002.51-1l8.41-8.36h.07c2.77 1.31 5.47.69 8-1.82A8 8 0 0028 12.14a7.49 7.49 0 00-.18-1.71z" })));
}
exports.default = SvgWrenchFilled;
//# sourceMappingURL=WrenchFilled.js.map